// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DtsNG2 {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-1);
}

.aurt5v {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  height: 28px;
}

.u2EZsB {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-3);
  align-self: stretch;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding: 16px;
  background: var(--product-card-background);
  border-radius: var(--radius-s);
  box-shadow: var(--card-box-shadow);
}

.eBmfmX {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease;
  padding: var(--spacing-1);
  border-radius: 8px;
}

.eBmfmX:hover {
  transform: none;
  background-color: rgba(0, 0, 0, 0.04);
}

.eBmfmX:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
  border-radius: 8px;
}

.cYHC1b {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.cYHC1b img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.ZxLpEJ {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-sm-regular-font-weight);
  font-size: var(--type-paragraph-sm-font-size);
  line-height: var(--type-paragraph-sm-regular-line-height);
  color: var(--text-neutral-dark);
  white-space: nowrap;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .u2EZsB {
    justify-content: center;
    gap: var(--spacing-3);
  }

  .cYHC1b {
    width: 32px;
    height: 32px;
  }

  .cYHC1b img {
    width: 32px;
    height: 32px;
  }

  .ZxLpEJ {
    font-size: var(--type-paragraph-xs-font-size);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/SocialLinks/SocialLinks.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,0CAA0C;EAC1C,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,6CAA6C;EAC/C;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-1);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  height: 28px;\n}\n\n.socialGrid {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-3);\n  align-self: stretch;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  padding: 16px;\n  background: var(--product-card-background);\n  border-radius: var(--radius-s);\n  box-shadow: var(--card-box-shadow);\n}\n\n.socialLink {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  text-decoration: none;\n  color: inherit;\n  transition: transform 0.2s ease;\n  padding: var(--spacing-1);\n  border-radius: 8px;\n}\n\n.socialLink:hover {\n  transform: none;\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.socialLink:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.socialIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n}\n\n.socialIcon img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n\n.socialText {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-sm-regular-font-weight);\n  font-size: var(--type-paragraph-sm-font-size);\n  line-height: var(--type-paragraph-sm-regular-line-height);\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .socialGrid {\n    justify-content: center;\n    gap: var(--spacing-3);\n  }\n\n  .socialIcon {\n    width: 32px;\n    height: 32px;\n  }\n\n  .socialIcon img {\n    width: 32px;\n    height: 32px;\n  }\n\n  .socialText {\n    font-size: var(--type-paragraph-xs-font-size);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DtsNG2`,
	"title": `aurt5v`,
	"socialGrid": `u2EZsB`,
	"socialLink": `eBmfmX`,
	"socialIcon": `cYHC1b`,
	"socialText": `ZxLpEJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
